import { LOGIN_PAGE_URL } from '@/api/core/links';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './core/Auth';

export function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    navigate(LOGIN_PAGE_URL, { replace: true });
  }, []);

  return null;
}
